import TempService from "../../services";
import { hasError } from "@/utils/utils";
export default {
  actions: {
    async updateFounder({ commit, dispatch }, payload) {
      commit("TempNgo/setWorking", true, { root: true });
      try {
        const res = await TempService.updateFounder(payload);
        commit("TempNgo/setWorking", false, { root: true });

        if (hasError(res.status)) {
          throw res.statusText;
        }
        dispatch("fetchNgoData");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async addFounder({ commit, dispatch }, payload) {
      commit("TempNgo/setWorking", true, { root: true });
      try {
        const res = await TempService.addFounder(payload);
        commit("TempNgo/setWorking", false, { root: true });

        if (hasError(res.status)) {
          throw res.statusText;
        }
        dispatch("fetchNgoData");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
    async deleteFounder({ commit, dispatch }, id) {
      commit("TempNgo/setWorking", true, { root: true });
      try {
        const res = await TempService.deleteFounder(id);
        commit("TempNgo/setWorking", false, { root: true });

        if (hasError(res.status)) {
          throw res.statusText;
        }
        dispatch("fetchNgoData");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
  },
};
